import { useMemo } from "react";
import { PlaceHolder } from "@/services/smsPlaceHolders/type";

interface CheckEmptyPreviewTagsProps {
  tags: PlaceHolder[];
  templateText: string;
}

export const useCheckEmptyPreviewTags = ({
  tags,
  templateText,
}: CheckEmptyPreviewTagsProps) => {
  const checkEmptyPreviewTags = useMemo(() => {
    if (!tags || !templateText) return [];
    const emptyTags = tags.filter((tag) => {
      const regex = new RegExp(tag.key || "", "g");
      return templateText.match(regex) && !tag.preView;
    });
    return emptyTags;
  }, [tags, templateText]);

  const hasEmptyPreviewTags = checkEmptyPreviewTags.length > 0;

  return {
    checkEmptyPreviewTags,
    hasEmptyPreviewTags,
  };
};
